import { PopoverOrigin } from '@mui/material';

import {
  colors,
  fonts,
  menuItem,
  menuPaper,
} from '../../theme';

const styles = {
  button: {
    gap: 0.75,
    px: 0.5,
    minWidth: 0,
    color: colors.text,
    textTransform: 'none',
    fontFamily: fonts.text,
    fontSize: 17,
    fontWeight: 800,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  chevron: {
    transition: 'transform 0.2s',
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  } as PopoverOrigin,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  } as PopoverOrigin,
  paperProps: {
    sx: {
      ...menuPaper,
      mt: 0.375,
      minWidth: 220,
    },
  },
  item: {
    ...menuItem,
    justifyContent: 'space-between',
    gap: 2,
  },
};

export default styles;
